export const formatCurrency = (amount?: string | number): string => {
  if (amount === undefined || amount === null || amount === '') return 'N/A';
  if (typeof amount === 'string') return amount;
  return String(amount);
}

export const formatDate = (date?: string): string => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-US');
}

export const formatBoolean = (value?: boolean): string => {
  if (value === undefined || value === null) return 'N/A';
  return value ? 'Yes' : 'No';
}